export function formatTimestamp(unixMs: number): string {
  return new Date(unixMs).toLocaleString('pl-PL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatRelative(unixMs: number): string {
  const absDiff = Math.abs(Date.now() - unixMs);
  const minutes = Math.floor(absDiff / (60 * 1000));
  const hours = Math.floor(absDiff / (60 * 60 * 1000));
  const days = Math.floor(hours / 24);
  if (absDiff < 60 * 1000) return 'przed chwilą';
  if (absDiff < 60 * 60 * 1000) return `${minutes} min temu`;
  if (hours < 24) return `${hours} godz. temu`;
  if (days < 7) return days === 1 ? 'wczoraj' : `${days} dni temu`;
  return new Date(unixMs).toLocaleDateString('pl-PL');
}

/** 1 powiadomienie, 2 powiadomienia, 5 powiadomień. */
export function pluralNotifications(n: number): string {
  if (n === 1) return '1 powiadomienie';
  const lastTwo = n % 100;
  const last = n % 10;
  if (last >= 2 && last <= 4 && (lastTwo < 12 || lastTwo > 14)) return `${n} powiadomienia`;
  return `${n} powiadomień`;
}
